const modNumeration = (num:string) =>{
  let no = num.replace("(", " (")
  no = no.replace("年", "年 ");
  no = no.replace("  ", " ")
  return no;
}
export default modNumeration;